import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaArrowLeft, FaPaperPlane } from "react-icons/fa";

const FeedbackPage = () => {
  const [feedback, setFeedback] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { client_key: clientKey } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const rating = searchParams.get("rating");
  const service = searchParams.get("platform");
  console.log("Full URL:", window.location.href);
  console.log("Search params:", searchParams.toString());
  console.log("Platform:", rating, service, searchParams.get("platform"));

  const quickFeedback = [
    "Long wait time",
    "Service quality",
    "Cleanliness",
    "Staff attitude",
    "Pricing",
    "Other",
  ];

  const [selectedTags, setSelectedTags] = useState([]);

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const handleFeedbackSubmit = async (skip = false) => {
    setIsSubmitting(true);

    try {
      const combinedFeedback = skip
        ? ""
        : [...selectedTags, feedback].filter(Boolean).join(". ");
      console.log(
        "Submitting feedback:",
        {
          feedback: combinedFeedback,
          rating: rating,
          platform: service || "uzeli",
        },
        JSON.stringify({
          feedback: combinedFeedback,
          rating: rating,
          platform: service || "uzeli",
        }),
      );

      await fetch(`/clients/${clientKey}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          feedback: combinedFeedback,
          rating: rating,
          platform: service || "uzeli",
        }),
      });
    } catch (e) {
      console.log(e);
    } finally {
      setIsSubmitting(false);
      navigate("/thankyou");
    }
  };

  const hasContent = feedback.trim() || selectedTags.length > 0;

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="flex flex-col justify-center items-center min-h-screen py-6 px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-gray-200/50 overflow-hidden">
          <div className="relative bg-gradient-to-r from-orange-400 to-orange-500 px-6 py-5 text-white">
            <button
              onClick={() => navigate(-1)}
              className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full hover:bg-white/20 transition-colors"
            >
              <FaArrowLeft size={16} />
            </button>
            <h1 className="text-xl font-semibold text-center">
              Share Your Thoughts
            </h1>
          </div>

          <div className="p-6">
            <div className="text-center mb-5">
              <p className="text-gray-700">
                We're sorry we didn't meet your expectations.
              </p>
              <p className="text-gray-500 text-sm mt-1">
                Please help us understand what went wrong.
              </p>
            </div>

            <div className="mb-4">
              <p className="text-sm font-medium text-gray-600 mb-2">
                Quick select:
              </p>
              <div className="flex flex-wrap gap-2">
                {quickFeedback.map((tag) => (
                  <button
                    key={tag}
                    onClick={() => toggleTag(tag)}
                    className={`
                      px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200
                      ${
                        selectedTags.includes(tag)
                          ? "bg-orange-500 text-white"
                          : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                      }
                    `}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>

            <textarea
              className="w-full p-4 border-2 border-gray-100 rounded-xl bg-gray-50 outline-none focus:border-orange-300 focus:bg-white transition-all duration-200 resize-none text-gray-700 placeholder-gray-400"
              placeholder="Tell us more about your experience..."
              rows={4}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />

            <p className="text-xs text-gray-400 mt-1 text-right">
              Private feedback - won't be posted publicly
            </p>

            <div className="flex gap-3 mt-5">
              <button
                onClick={() => {
                  navigate("/thankyou");
                }}
                className="flex-1 py-3.5 rounded-xl text-base font-semibold bg-gray-100 text-gray-600 hover:bg-gray-200 transition-all duration-200 active:scale-[0.98] disabled:opacity-50"
              >
                Skip
              </button>
              <button
                onClick={() => handleFeedbackSubmit(false)}
                disabled={!hasContent || isSubmitting}
                className={`
                  flex-1 py-3.5 rounded-xl text-base font-semibold transition-all duration-200 active:scale-[0.98]
                  flex items-center justify-center gap-2
                  ${
                    hasContent && !isSubmitting
                      ? "bg-gradient-to-r from-orange-400 to-orange-500 text-white shadow-lg shadow-orange-200 hover:shadow-xl"
                      : "bg-gray-100 text-gray-400 cursor-not-allowed"
                  }
                `}
              >
                {isSubmitting ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  <>
                    <FaPaperPlane size={14} />
                    Submit
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;
